import { render, staticRenderFns } from "./RiwayatPengajuan.vue?vue&type=template&id=33a516fe&"
import script from "./RiwayatPengajuan.vue?vue&type=script&lang=js&"
export * from "./RiwayatPengajuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports